module.exports = __webpack_public_path__ + "img/tuek-thla-branch.4fbb770f.jpg";